export const STEP_SLUG = 'choose-niche';
export const PLATFORM = 'shopify';

export const storeBuilderIconUrl =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/9568512627a2561e288b5d6613230534-1749564654941/storeIcon.png';

export const VIDEO = {
    src: 'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd/v1/video-attachments/generic_asset/asset/870f6859b599c9b33ebbaaa98dc547fd-1748508004965/Floating%20Gif%20%282%29',
    type: 'video/mp4',
};
